import axios from "axios";
import { message as AntdAlert } from "antd";
import { put } from "redux-saga/effects";
import * as actions from "../actions";
import { baseURL } from "../../../../globalUtils/axiosConfig";
import { errorHandler } from "../../../../components/unauthorizeHandler";

export function* handleFetchAllTemplates({ data }) {
  const { search = {}, ...rest } = data;
  
  // Clean up search parameters
  const cleanedSearch = {};
  Object.keys(search).forEach((key) => {
    if (search[key]?.length >= 1 && search[key] !== null) {
      cleanedSearch[key] = search[key];
    }
  });

  try {
    const response = yield axios.get(`${baseURL}/material_template`, {
      params: { ...rest, ...cleanedSearch },
    });
    if (response.status === 200) {
      const { materialTemplates, page, perPage, total } = response.data;
      const transformedTemplates = materialTemplates.map(template => ({
        ...template,
        name: template.name,
        project: template.project?.projectNumber || 'N/A',
        client: template.project?.client || 'N/A'
      }));
      
      yield put(actions.fetchAllTemplatesSuccess({
        allTemplates: transformedTemplates,
        page,
        resultPerPage: perPage,
        totalRecords: total
      }));
    }
    errorHandler(response.data);
  } catch (error) {
    AntdAlert.error("Something went wrong!");
    yield put(actions.fetchAllTemplatesError());
    console.log(error);
  }
}

export function* handleUpdateTemplates({ data }) {
  const { navigate, updateData, id } = data;
  console.log("handleUpdateTemplates",  { ...updateData });
  
  try {
    const response = yield axios.patch(
      `${baseURL}/material_template/${id}`,
      { ...updateData }
    );
    if (response.status === 200) {
      AntdAlert.success("Template updated successfully");
      yield put(actions.updateTemplatesSuccess(data));
      // navigate("/settings/material-templates");
    } else {
      AntdAlert.error(response.data.message);
      yield put(actions.updateTemplatesError(response.data.data));
      errorHandler(response.data);
    }
  } catch ({ response }) {
    yield put(actions.updateTemplatesError(response.data.data));
    AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}
export function* handleDeleteTemplate({ data }) {
  try {
    const response = yield axios.delete(
      `${baseURL}/material_template/${data.id}`
    );
    if (response.status === 200) {
      AntdAlert.success("Template deleted successfully");
      yield put(actions.deleteTemplateSuccess(response.data.data));
    } else {
      errorHandler(response.data);
      yield put(actions.deleteTemplateError(response.data.data));
    }
  } catch ({ response }) {
    yield put(actions.deleteTemplateError(response.data.data));
    AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}
export function* handleCreateTemplate({ data }) {
  console.log("handleCreateTemplate", data);
  
  const { navigate, projectId, ...rest } = data;
  try {
    const response = yield axios.post(`${baseURL}/material_template`, {
      projectId,
      ...rest,
    });
    
    if (response.status === 201) {
      AntdAlert.success("Template created successfully");
      yield put(actions.createTemplateSuccess(response.data));
      
      // Small delay to allow the success state to be processed
      yield new Promise(resolve => setTimeout(resolve, 100));
      
      // navigate("/settings/material-templates");
    } else {
      const errorMessage = response.data?.message || 'Failed to create template';
      AntdAlert.error(errorMessage);
      yield put(actions.createTemplateError());
      errorHandler(response.data);
    }
  } catch (error) {
    console.error('Error creating template:', error);
    const errorMessage = error.response?.data?.message || 'Failed to create template. Please try again.';
    AntdAlert.error(errorMessage);
    yield put(actions.createTemplateError());
    
    if (error.response) {
      errorHandler(error.response.data);
    }
  }
}

export function* handleFetchTemplate(data) {  
  try {
    const response = yield axios.get(
      `${baseURL}/material_template/${data.data}`
    );
    if (response.status === 200) {
      yield put(actions.fetchTemplateSuccess(response.data));
    } else {
      AntdAlert.error(response.data.message);
      yield put(actions.fetchTemplateError());
      errorHandler(response.data);
    }
  } catch (error) {
    AntdAlert.error("Something went wrong!");
    yield put(actions.fetchTemplateError());
    console.log(error);
  }
}
